import './style.css';
import { Engine } from './core/Engine';

// ============================================
// 03:11 — La Frecuencia Muerta
// Punto de entrada del juego
// ============================================

async function main(): Promise<void> {
  const container = document.getElementById('app');
  if (!container) {
    console.error('[Main] No se encontró el contenedor #app');
    return;
  }

  // Mostrar pantalla de carga
  container.innerHTML = `
    <div id="loading-screen">
      <div class="loading-content">
        <h1>03:11</h1>
        <h2>La Frecuencia Muerta</h2>
        <div class="loading-bar">
          <div class="loading-progress"></div>
        </div>
        <p class="loading-text">Sintonizando frecuencia...</p>
      </div>
    </div>
  `;

  try {
    // Inicializar motor
    const engine = new Engine(container);
    await engine.init();

    // Ocultar pantalla de carga
    const loadingScreen = document.getElementById('loading-screen');
    if (loadingScreen) {
      loadingScreen.classList.add('fade-out');
      setTimeout(() => loadingScreen.remove(), 1000);
    }

    // Crear contenedor para el canvas
    const gameContainer = document.createElement('div');
    gameContainer.id = 'game-container';
    container.appendChild(gameContainer);

    // Iniciar juego
    engine.start();

    // Eventos de teclado globales
    document.addEventListener('keydown', (e) => {
      if (e.code === 'Escape') {
        if (engine['state'].isPaused) {
          engine.resume();
        } else {
          engine.pause();
        }
      }

      if (e.code === 'KeyE') {
        // Interacción se maneja en InteractionSystem
      }
    });

    // Manejar visibilidad de la página
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        engine.pause();
      }
    });

    console.log('[Main] Juego iniciado correctamente');
  } catch (error) {
    console.error('[Main] Error al inicializar el juego:', error);
    container.innerHTML = `
      <div id="error-screen">
        <h1>Error</h1>
        <p>No se pudo inicializar el juego.</p>
        <p class="error-details">${error instanceof Error ? error.message : 'Error desconocido'}</p>
      </div>
    `;
  }
}

// Iniciar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', main);
} else {
  main();
}
